import { graphql, PageProps } from "gatsby";
import { FC } from "react";

import { PageMeta } from "@/components/elements";
import { MainLayout } from "@/components/layout";
import { NavbarLink } from "@/features/navbar";
import { Story, StoryProps } from "@/features/story";

interface QueryResult {
  navbar: {
    frontmatter: {
      navbarLinks: NavbarLink[];
    };
  };
  stories: {
    frontmatter: Omit<StoryProps, "html">;
    html: string;
  };
}

const StoryTemplate: FC<PageProps<QueryResult>> = ({
  data,
}: PageProps<QueryResult>): JSX.Element => {
  const html = data.stories.html;
  const { bgImg, pageTitle, heading, descr, related } = data.stories.frontmatter;
  const { navbarLinks } = data.navbar.frontmatter;

  return (
    <MainLayout navbarLinks={navbarLinks}>
      <PageMeta isTemplate title={pageTitle} category={"Stories"} description={descr} />
      <Story
        bgImg={bgImg}
        pageTitle={pageTitle}
        heading={heading}
        html={html}
        related={related ?? []}
      />
    </MainLayout>
  );
};

export const query = graphql`
  query StoryPageQuery($id: String) {
    navbar: markdownRemark(fields: { collection: { eq: "navbar" } }) {
      frontmatter {
        navbarLinks {
          label
          url
        }
      }
    }
    stories: markdownRemark(id: { eq: $id }) {
      frontmatter {
        pageTitle
        descr
        heading
        bgImg {
          childImageSharp {
            gatsbyImageData(quality: 100, height: 410)
          }
        }
        related {
          color
          bgColor
          textMd
          url
          borderColor
          textAlignment
        }
      }
      html
    }
  }
`;

export default StoryTemplate;
